var _rect, _g, _rect2, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgControllerUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 375,
    height: 57,
    viewBox: "0 0 375 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1988_7275",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 375,
    height: 57
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 375,
    height: 57,
    fill: "#D9D9D9"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1988_7275)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1988_7275)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M143.834 38.6765C151.702 38.6765 158.064 32.6784 161.965 25.8453C167.412 16.3033 176.814 10 187.5 10C198.186 10 207.588 16.3033 213.035 25.8453C216.936 32.6784 223.298 38.6765 231.166 38.6765H359C367.837 38.6765 375 45.8399 375 54.6765V54.6765C375 62.5871 368.587 69 360.676 69H14.3236C6.41288 69 0 62.5871 0 54.6765V54.6765C0 45.8399 7.16344 38.6765 16 38.6765H143.834Z",
    fill: "#FFFDFC"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1988_7275",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 171,
    y: 18,
    width: 32,
    height: 32
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 203,
    y: 18,
    width: 32,
    height: 32,
    transform: "rotate(90 203 18)",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1988_7275)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M201 38.5269C201 39.387 200.683 40.2477 200.045 40.9201C198.725 42.3101 196.529 42.3655 195.14 41.0444L186.976 33.2735L178.868 41.0364C177.484 42.3624 175.288 42.3137 173.963 40.9274C172.637 39.5405 172.687 37.3422 174.072 36.0162L184.569 25.9631C185.907 24.6815 188.016 24.6791 189.358 25.9551L199.921 36.0077C200.637 36.6917 201 37.6072 201 38.5269Z",
    fill: "#436094"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1988_7275",
    x: -12,
    y: -2,
    width: 399,
    height: 83,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.488845 0 0 0 0 0.488845 0 0 0 0 0.488845 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1988_7275"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1988_7275",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgControllerUp);
export default __webpack_public_path__ + "static/media/controller_up.3099fecec5153ed6906d57b78e7de511.svg";
export { ForwardRef as ReactComponent };